import { useGetApiCompaniesCurrentServiceconnections } from '@/api/generated/company-management-user/company-management-user'
import type { ServiceConnectionModel } from '@/api/model'
import { TableCard } from '@/components/common/table/TableCard'
import { ServiceConnectionsDataTable } from './ServiceConnectionsDataTable'

interface Props {
  canEdit: boolean
  onEdit: (connection: ServiceConnectionModel) => void
}

export function ServiceConnectionsTable({ canEdit, onEdit }: Props) {
  // The endpoint returns every connection of the company at once — no paging, no sorting.
  const { data, isLoading, isError } = useGetApiCompaniesCurrentServiceconnections()
  const connections = data?.data ?? []

  return (
    <TableCard>
      <div className="flex-1 overflow-auto scrollbar-custom p-0 relative">
        <ServiceConnectionsDataTable
          isLoading={isLoading}
          isError={isError}
          connections={connections}
          canEdit={canEdit}
          onEdit={onEdit}
        />
      </div>
    </TableCard>
  )
}
